import { useQuery } from '@tanstack/react-query'

import type { MargoCallReport } from '@mangovoice/margo-call-analytics-client'

import { fetchMargoCallReport } from './MargoSummary.api'
import type { MargoCallReportRequestError } from './MargoSummary.api'

interface UseMargoCallReportParams {
  callId?: number
  pbxId?: number
}

export const useMargoCallReport = ({
  callId,
  pbxId,
}: UseMargoCallReportParams) =>
  useQuery<MargoCallReport | null, MargoCallReportRequestError>({
    queryKey: ['margoCallReport', callId, pbxId],
    queryFn: () =>
      callId && pbxId ? fetchMargoCallReport(callId, pbxId) : null,
    enabled: Boolean(callId && callId > 0 && pbxId && pbxId > 0),
    retry: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
  })
